export const BUDGET_LINEITEM_NAME_INTEREST = "Interest";

export const BUDGET_ITEMS_DIRECT = [
  ["seed", "Seed"],
  ["irrigation", "Irrigation"],
  ["labor", "Labor"],
  ["custom_farm_work", "Custom Work"],
  ["repairs_maintenance", "Repairs"],
  ["fuel", "Fuel"],
  ["chemical_insecticide_herbicide", "Chemicals"],
  ["fertilizer", "Fertilizer"],
  ["crop_insurance", "Crop Insurance"],
];

export const BUDGET_ITEMS_INDIRECT = [
  ["cash_rent", "Cash Rent"],
  ["equipment_machinery", "Equipment"],
  ["interest_estimated", "Interest"],
  ["miscellaneous", "Misc."],
];

export const BUDGET_LINEITEMS = [...BUDGET_ITEMS_DIRECT, ...BUDGET_ITEMS_INDIRECT];

export const BUDGET_COST_DEFAULTS = [
  ...BUDGET_ITEMS_DIRECT.map(([key]) => ({ category: "direct", name: key })),
  ...BUDGET_ITEMS_INDIRECT.map(([key]) => ({ category: "indirect", name: key })),
];

// Same as templates: i[0] is the stored/template key, i[1] is the line name.
const compactLineItemName = (name) =>
  String(name ?? "")
    .replace(/\s*\((direct|indirect)\)$/i, "")
    .replace(/[^a-z0-9]/gi, "")
    .toLowerCase();

export const budgetItemOf = (name) => {
  const compact = compactLineItemName(name);
  return BUDGET_LINEITEMS.find(
    ([key, label]) => compactLineItemName(key) === compact || compactLineItemName(label) === compact
  );
};

const budgetCategoryOf = (name) => {
  const item = budgetItemOf(name);
  if (!item) return null;
  return BUDGET_ITEMS_DIRECT.some(([key]) => key === item[0]) ? "direct" : "indirect";
};

/** Template key or label → the label shown to the user (`Chemicals`). */
export const budgetLineItemLabel = (name) => budgetItemOf(name)?.[1] || name || "";

/** Template key or label → the name written to the API (`chemical_insecticide_herbicide`). */
export const budgetLineItemStoredName = (name) => budgetItemOf(name)?.[0] || name || "";

/** Same cost if both names are that item's key or its label. */
export const budgetLineItemKey = (name) => compactLineItemName(budgetLineItemLabel(name));

/**
 * Templates sometimes store the BUDGET_ITEMS key in `category` (`chemicals`) instead of direct/indirect.
 * A schedule row's product name still belongs to that cost.
 */
export const budgetCostKey = (category, name) => {
  const item = budgetItemOf(name) || budgetItemOf(category);
  const cat = /^(direct|indirect)$/i.test(category ?? "")
    ? String(category).toLowerCase()
    : budgetCategoryOf(category) || budgetCategoryOf(item?.[1]) || String(category ?? "").toLowerCase();
  return `${cat}::${compactLineItemName(item?.[1] ?? name)}`;
};
